import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faLock,
  faUsersGear,
  faPlus,
  faEye,
  faEyeSlash,
  faEdit,
  faTrash,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import "./classes/Main.css";
import "./classes/ManageUsers.css";

const API_BASE = configData.APP_URL;

const ManageUsers = () => {
  const mockdata = [
  {
    id: 1,
    username: "admin",
    role: "1",
    role_name: "admin",
    created_at: "2025-02-10T09:30:00Z",
  },
  {
    user_id: 2,
    user_name: "sales_user",
    role: "2",
    role_name: "cashier",
    created: "2025-02-12T14:45:00Z",
  },
  {
    id: 3,
    username: "manager01",
    role: "3",
    role_name: "cashier",
    date_created: "2025-02-15T08:20:00Z",
  },
  {
    user_id: 4,
    user_name: "cashier",
    role: "2",
    role_name: "cashier",
    created_at: "2025-02-18T11:10:00Z",
  },
  {
    id: 5,
    username: "demo_user",
    role: null,                 // tests fallback "—"
    created: null,              // tests fallback "—"
  },
];
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    role: "2",
  });
  
  const [showPassword, setShowPassword] = useState(false);

  const [modal, setModal] = useState(false);
const [editingId, setEditingId] = useState(null);

const [editFormData, setEditFormData] = useState({
  username: "",
  role: "2",
});

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}users/list`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setUsers(data);
      } else if (data?.data && Array.isArray(data.data)) {
        setUsers(data.data);
      } else if (data?.users && Array.isArray(data.users)) {
        setUsers(data.users);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
//  useEffect(() => {
//         setLoading(true);
//         setTimeout(() => {
//             setUsers(mockdata);
//             setLoading(false);
//         }, 800);
//     }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleUserCreate = async (e) => {
  e.preventDefault();

  if (!formData.username.trim() || !formData.password.trim()) {
    alert("Username and password are required");
    return;
  }

  setSubmitting(true);
  try {
    const response = await fetch(`${API_BASE}users/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to create user");
    }

    alert("User created successfully");
    setFormData({ username: "", password: "", role: "2" });
    setShowPassword(false);
    fetchUsers();
  } catch (error) {
    console.error("Error:", error);
    alert(error.message);
  } finally {
    setSubmitting(false);
  }
};
const handleEdit = (user) => {
  const id = user.id ?? user.user_id;

  setEditFormData({
    username: user.username ?? user.user_name ?? "",
    role: user.role ?? "2",
  });

  setEditingId(id);
  setModal(true);
};
const handleEditSubmit = async (e) => {
  e.preventDefault();

  if (!editFormData.username.trim()) {
    alert("Username is required");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}users/update/${editingId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editFormData),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to update user");

    alert("User updated successfully");
    setModal(false);
    setEditingId(null);
  } catch (err) {
    alert(err.message);
  }
};
const handleCancelEdit = () => {
  setModal(false);
  setEditingId(null);
  setEditFormData({ username: "", role: "2" });
};
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  try {
    const res = await fetch(`${API_BASE}users/delete/${id}`, {
      method: "DELETE",
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to delete user");

    alert("User deleted successfully");
  } catch (err) {
    alert(err.message);
  }
};

  return (
    <div className="pos-main manage-users-container">
      <Helmet>
        <title>Manage Users</title>
      </Helmet>

      <div className="main">
        {/* LEFT */}
        <div className="left-container">
          <span className="create-user-title">
            <FontAwesomeIcon icon={faUsersGear} />
            <h3>User Management</h3>
          </span>

          <div className="create-user-container">
            <h2>Create New User</h2>

            <form onSubmit={handleUserCreate}>
              {/* USERNAME */}
              <div className="login-form-field">
                <label htmlFor="username">Username</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <input
                    id="username"
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* PASSWORD */}
              <div className="login-form-field">
                <label htmlFor="password">Password</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faLock} />
                  </span>

                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={handleChange}
                  />

                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                    />
                  </span>
                </div>
              </div>

              {/* ROLE */}
              <div className="login-form-field">
                <label htmlFor="role">Role</label>
                <div className="login-input-container">
                  <select
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                  >
                    <option value="2">Cashier (POS Only)</option>
                    <option value="1">Admin (Full Access)</option>
                  </select>
                </div>
              </div>

              {/* SUBMIT */}
              <button type="submit" className="login-form-submit" disabled={submitting}>
                <FontAwesomeIcon icon={faPlus} /> {submitting ? "Creating..." : "Create User"}
              </button>
            </form>
          </div>
        </div>

        {/* RIGHT */}
        <div className="product-search-container">
          <span className="existing-users-header"><FontAwesomeIcon icon={faUserCheck} /><h3>Existing Users</h3></span>
        {loading ? (
  <p className="no-data-message">Loading users...</p>
) : users.length === 0 ? (
  <p className="no-data-message">No users yet. Create one using the form.</p>
) : (
  <>
    {/* ===== DESKTOP TABLE ===== */}
    <div className="user-table-wrapper user-table-desktop">
      <table className="existing-users-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Role</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const id = user.id ?? user.user_id;
            const username = user.username ?? user.user_name ?? "—";
            const role = user.role ?? "—";
            const role_name = user.role_name ?? "—";
            const created =
              user.created_at ?? user.created ?? user.date_created;

            return (
              <tr key={id}>
                <td>{username}</td>
                <td>{role_name}</td>
                <td>{created ? new Date(created).toLocaleString() : "—"}</td>
                <td className="icon-cell">
                  <span
                    className="action-icon edit"
                    onClick={() => handleEdit(user)}
                    title="Edit"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </span>

                  {role !== "1" && (
                    <span
                      className="action-icon delete"
                      onClick={() => handleDelete(id)}
                      title="Delete"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>

    {/* ===== MOBILE CARDS ===== */}
    <div className="users-cards-mobile">
      {users.map((user) => {
        const id = user.id ?? user.user_id;
        const username = user.username ?? user.user_name ?? "—";
        const role = user.role ?? "—";
        const role_name = user.role_name ?? "—";
        const created =
          user.created_at ?? user.created ?? user.date_created;

        return (
          <div key={id} className="user-card">
            <div className="user-card-main">
              <span className="user-card-name">{username}</span>
              <span className="user-card-role">{role_name}</span>
            </div>

            <div className="user-card-secondary">
              <span>
                Created: {created ? new Date(created).toLocaleDateString() : "—"}
              </span>
            </div>

            <div className="user-card-actions">
              <button
                type="button"
                className="action-btn edit"
                onClick={() => handleEdit(user)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </button>

              {role !== "1" && (
                <button
                  type="button"
                  className="action-btn delete"
                  onClick={() => handleDelete(id)}
                >
                  <FontAwesomeIcon icon={faTrash} /> Delete
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  </>
)}
        </div>
        {modal && (
  <div className="manage-customer-modal">
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit User</h2>

        <form onSubmit={handleEditSubmit}>
          <table>
            <tbody>
              <tr className="login-form-field login-form-field-modal">
                <td><label>Username *</label></td>
                <td>
                  <input
                    type="text"
                    value={editFormData.username}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, username: e.target.value })
                    }
                  />
                </td>
              </tr>

              <tr className="login-form-field login-form-field-modal">
                <td><label>Role</label></td>
                <td>
                  <select
                    value={editFormData.role}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, role: e.target.value })
                    }
                  >
                    <option value="cashier">Cashier</option>
                    <option value="admin">Admin</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td colSpan={2}>
                  <div className="modal-buttons">
                    <button type="submit">Update</button>
                    <button type="button" onClick={handleCancelEdit}>
                      Cancel
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default ManageUsers;